var $dd9fccd10d0a4be3$exports = {};
$dd9fccd10d0a4be3$exports = {
    "(optional)": `(op\u{163}ional)`,
    "(required)": `(obligatoriu)`
};


export {$dd9fccd10d0a4be3$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
